import { getAuth } from "@/lib/auth";
import { PERMISSIONS, type AppAction, type AppResource, type AppRole } from "@cdc-sccr/shared";

/**
 * Returns a `can(action, resource)` helper scoped to the current user's role.
 * Reads from the central PERMISSIONS map in packages/shared.
 */
export function usePermissions() {
  const auth = getAuth();
  const role = (auth?.user.role ?? "driver") as AppRole;

  if (auth?.user.isSuperAdmin) {
    return { can: (_action: AppAction, _resource: AppResource) => true, role };
  }

  function can(action: AppAction, resource: AppResource): boolean {
    return PERMISSIONS[role]?.[resource]?.[action] ?? false;
  }

  return { can, role };
}
